import { render, staticRenderFns } from "./TravelExpreses.vue?vue&type=template&id=a4d32b5a&scoped=true"
import script from "./TravelExpreses.vue?vue&type=script&lang=ts"
export * from "./TravelExpreses.vue?vue&type=script&lang=ts"
import style0 from "./TravelExpreses.vue?vue&type=style&index=0&id=a4d32b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d32b5a",
  null
  
)

export default component.exports